
import { defineComponent, onMounted, ref, reactive } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";

import AddProduct from "@/components/1crm/product/data-product/add-product.vue";

export default defineComponent({
  name: "Cabang",
  components: {
    ErrorMessage,
    Field,
    Form,
    AddProduct,
  },

  setup() {
    onMounted(() => {
      store.dispatch(Actions.VERIFY_AUTH);
      setCurrentPageBreadcrumbs("Tambah Produk", ["Data"]);
    });
  },
});
